import authenticatedRequest from '../authenticatedRequest';
import invariant from 'invariant';
import labelRequest from '../labelRequest';

export default function createWishlist(descriptionName, wishlistConfigs) {
    const { baseUrl, brandId, country, uberToken, clientId, clientSecret } = wishlistConfigs;

    invariant(baseUrl, 'baseUrl is a required param of createWishlist()');
    invariant(brandId, 'brandId is a required param of createWishlist()');
    invariant(country, 'country is a required param of createWishlist()');
    invariant(uberToken, 'uberToken is a required param of createWishlist()');
    invariant(clientId, 'clientId is a required param of createWishlist()');
    invariant(descriptionName, 'descriptionName is a required param of createWishlist()');

    const createURL = `${baseUrl}wcs/resources/store/${brandId}_${country.toLowerCase()}/wishlist`;

    const headers = { 'Content-Type': 'application/json' };

    const body = JSON.stringify({
        descriptionName,
    });

    return labelRequest(
        authenticatedRequest(new Request(createURL, { headers: new Headers(headers), method: 'POST', body }), uberToken, clientId, clientSecret),
        'createWishlist',
    );
}
